import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'curbnturf-rating-availability-toggle',
  templateUrl: './rating-availability-toggle.component.html',
  styleUrls: ['./rating-availability-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingAvailabilityToggleComponent),
      multi: true,
    },
  ],
  standalone: true,
})
export class RatingAvailabilityToggleComponent {
  @Input() selection: string = '';

  @Input() label: string;

  @Input() disabled: boolean = false;

  @Output() selectChange: EventEmitter<string> = new EventEmitter<string>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (id?: string) => void = (id?: string) => {
    /**/
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onTouched: (id?: string) => void = (id?: string) => {
    /**/
  };

  writeValue(obj: string): void {
    this.selection = obj;
  }

  registerOnChange(fn: (id?: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (id?: string) => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(value: string) {
    if (!this.disabled) {
      this.selection = value;
      this.selectChange.emit(this.selection);
      this.onChange(this.selection);
      this.onTouched();
    }
  }
}
